module.exports = __webpack_public_path__ + "media/printed-materials/educators-05-college-calendar-c2479723.jpg";